import { ERRORS_PATH } from "./internal/constants";
import { lensPath } from "../fp";

const errorsLens = lensPath(ERRORS_PATH);

export default errorsLens;
